import { Navigate, useParams } from '@user-management/router';

export default function RoleAndPermissionIndexPage() {
  const { appRoleId } = useParams('/roles-and-permissions/:appRoleId');

  return <Navigate to='/roles-and-permissions/:appRoleId/details' params={{ appRoleId }} replace />;
}
